module.exports = __webpack_public_path__ + "static/img/icon_cloud3.1722849.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud3.jpg
// module id = kUW5
// module chunks = 21